import { LocalTimeElement } from "@github/time-elements"

// Behaves like local-time, except uses the current time plus an offset.
// Offset should be in the "offset" attribute in seconds
class ExampleLocalTimeElement extends LocalTimeElement {
  connectedCallback() {
    const offset = parseInt(this.getAttribute("offset") || 0)
    this.setAttribute("datetime", new Date(Date.now() + offset * 1000))
    super.connectedCallback()
  }
}
customElements.define("example-local-time", ExampleLocalTimeElement)
